export enum IndirectQuoteType {
  Underwriter = 1, // The quote the user modifies to send back to the dealers
  Recommended = 2, // The calculated recommendations
  DealerRequested = 3 // What comes from Dealertrack, RouteOne, or DealerFlow
}